import { API_HOST, API_PROTOCOL } from '@/env';
import Agent from 'agentkeepalive';
import axios from 'axios';

// Api configurations
const keepaliveAgent = new Agent({
  maxSockets: 100,
  maxFreeSockets: 10,
  timeout: 60000, // active socket keepalive for 60 seconds
  freeSocketTimeout: 30000, // free socket keepalive for 30 seconds
});

export const protocol = API_PROTOCOL;
export const host = API_HOST;
export const baseURL = `${protocol}://${host}`;
const headers = {
  'Content-Type': 'application/json',
  'X-Requested-With': 'XMLHttpRequest',
};
const xsrfHeaderName = 'X-CSRFTOKEN';
const xsrfCookieName = 'csrftoken';
// const withCredentials = true;
const httpAgent = keepaliveAgent;

export const http = axios.create({
  baseURL,
  headers,
  withCredentials: false,
  xsrfCookieName,
  xsrfHeaderName,
  httpAgent,
});
